<template>
  <section>
    <v-container fluid grid-list-md>
      <page-title :title="$t('iscritti.title')" />
      <v-form @keyup.native.enter="search" class="mt-4">
        <v-layout row wrap>
          <v-flex md4>
            <v-text-field v-model="q" clearable :label="$t('iscritti.cerca')" type="text" />
          </v-flex>
          <v-flex md5>
            <v-btn color="primary" @click="search" :disabled="!q">
              <v-icon>search</v-icon> {{ $t('iscritti.cta1') }}
            </v-btn>
            <v-btn color="primary" @click="multiconfirm = true" v-if="userArrayIsNotEmpty">
              <v-icon>send</v-icon> {{ $t('iscritti.selezionati') }}
            </v-btn>
            <v-btn
              color="red"
              class="white--text"
              @click="deselectAllUsers"
              v-if="userArrayIsNotEmpty"
            >
              <v-icon>deselect</v-icon> {{ $t('iscritti.deseleziona') }}
            </v-btn>
            <v-btn @click="resetSearch" v-if="hasSearched">
              <v-icon>undo</v-icon> {{ $t('iscritti.cta2') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-container>
      <v-btn color="primary" @click="$router.push({ name: 'controlpanel' })">{{
        $t('iscritti.cta4')
      }}</v-btn>
    </v-container>
    <v-container fluid grid-list-md class="pt-0">
      <v-layout row wrap justify-center class="mb-3">
        <v-pagination v-model="page" :length="pagination.lastPage"></v-pagination>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-data-table
          dense
          item-key="id"
          :headers="headers"
          :items="getInTouchList"
          class="elevation-1"
          :hide-actions="true"
        >
          <template v-slot:items="props">
            <td>
              <v-btn @click="$router.push({ name: 'controlpanel', params: { id: props.item.id }})" color="primary" x-small>
                <v-icon small>tune</v-icon>
              </v-btn>
            </td>
            <td>
              <v-checkbox
                hide-details
                @change="handleCheckboxChange(props.item)"
                :id="props.item.id"
              ></v-checkbox>
            </td>
            <td>
              <v-chip class="ma-2" label>
                <v-icon start>{{ 'account_circle' }}</v-icon>
                &nbsp;
                {{ props.item.name }} {{ props.item.surname }}
              </v-chip>
            </td>
            <td>
              <v-chip class="ma-2" label>
                <v-icon start>{{ 'mail' }}</v-icon>
                &nbsp;
                {{ props.item.email }}
              </v-chip>
              <v-chip class="ma-2" label v-if="props.item.google_mail">
                <img class="g-icon" src="../../assets/google_icon.svg" alt="google_icon.svg" />
                &nbsp;
                {{ props.item.google_mail }}
              </v-chip>
            </td>
            <td>
              <v-chip
                class="ma-2"
                color="pink lighten-4"
                text-color="pink"
                append-icon="mdi-star"
                v-for="item of props.item.tag.split(',')"
                :key="item"
                small
              >
                <v-icon start color="pink lighten-1">label</v-icon>
                &nbsp;
                <b>{{ item }}</b>
              </v-chip>
            </td>
            <td>
              <v-btn
                color="primary"
                @click="
                  confirm = true;
                  userItem = props.item;
                "
              >
                {{ $t('iscritti.cta3') }}
              </v-btn>
              <!-- Abilito la modale con confirm; Aggiorno il valore di userItem con utente cliccato -->
            </td>
            <td>
              {{ props.item.sended ? '&#9989;' : '&#10060;' }}
            </td>
            <td>
              <v-btn
                color="error"
                @click="
                  finalconfirm = true;
                  userItem = props.item;
                "
              >
                {{ $t('iscritti.cta3') }}
              </v-btn>
            </td>
            <td>
              {{ props.item.final_mail_sent ? '&#9989;' : '&#10060;' }}
            </td>
          </template>
        </v-data-table>
      </v-layout>
      <v-layout row wrap justify-center v-if="pagination && pagination.lastPage" class="mt-3">
        <v-pagination v-model="page" :length="pagination.lastPage"></v-pagination>
      </v-layout>
      <!-- conferma invio -->
      <v-dialog v-model="confirm" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            <span>{{ $t('iscritti.modale1.title') }}</span>
          </v-card-title>
          <v-card-text>
            <span
              >{{ $t('iscritti.modale1.body') }} {{ userItem.name }} {{ userItem.surname }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="confirm = false">
              <span>{{ $t('iscritti.modale1.cta1') }}</span>
            </v-btn>
            <v-btn color="error" flat @click.native="sendChangeEmail(userItem)">{{
              $t('iscritti.modale1.cta2')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- conferma invio EMAIL FINALE -->
      <v-dialog v-model="finalconfirm" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            <span>{{ $t('iscritti.modale2.title') }}</span>
          </v-card-title>
          <v-card-text>
            <span
              >{{ $t('iscritti.modale2.body') }} {{ userItem.name }} {{ userItem.surname }}
              {{ $t('iscritti.modale2.body2') }} {{ userItem.google_mail }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="finalconfirm = false">
              <span>{{ $t('iscritti.modale2.cta1') }}</span>
            </v-btn>
            <v-btn
              color="error"
              flat
              @click.native="sendFinalEmail(userItem.google_mail, userItem.id)"
              >{{ $t('iscritti.modale1.cta2') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- conferma multi-invio -->
      <v-dialog v-model="multiconfirm" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            <span>{{ $t('iscritti.modale3.title') }}</span>
          </v-card-title>
          <v-card-text>
            <span>{{ $t('iscritti.modale3.body') }}</span>
            <div v-for="addresses in selectedUsers" :key="addresses">
              {{ addresses.email }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="multiconfirm = false">
              <span>{{ $t('iscritti.modale3.cta1') }}</span>
            </v-btn>
            <v-btn color="error" flat @click.native="sendToSelected()">{{
              $t('iscritti.modale3.cta2')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>
<script>
import pageTitle from '@/components/common/PageTitle';
import { $EventBus } from '@/eventBus';
import _union from 'lodash/union';
import _ from 'lodash';

export default {
  data: () => ({
    headers: [],
    pagination: null,
    getInTouchList: [],
    total: null,
    hasSearched: null,
    limit: 18,
    page: 1,
    q: null, // chiave di ricerca
    confirm: null,
    multiconfirm: null,
    finalconfirm: null,
    selectedUsers: [],
    userItem: '',
  }),
  components: {
    pageTitle,
  },
  watch: {
    '$route.query'(newValue, oldValue) {
      if (newValue.page) {
        this.page = Number(newValue.page);
      } else {
        this.page = 1;
      }
      this.q = newValue.q;
      this.getList();
    },
    page(newValue) {
      if (newValue !== +this.$route.query.page) {
        this.$router.push({ path: '/getintouch', query: { ...this.$route.query, page: newValue } });
      }
    },
  },
  computed: {
    userArrayIsNotEmpty() {
      if (this.selectedUsers.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleCheckboxChange(item) {
      if (_.includes(this.selectedUsers, item)) {
        // La checkbox è stata deselezionata, quindi rimuovi il valore dall'array
        _.pull(this.selectedUsers, item);
      } else {
        // La checkbox è stata selezionata, quindi aggiungi il valore all'array
        this.selectedUsers.push(item);
      }
    },
    sendToSelected() {
      for (var i = 0; i < this.selectedUsers.length; i++) {
        this.sendChangeEmail(this.selectedUsers[i]);
      }
    },
    deselectAllUsers() {
      this.selectedUsers = [];
    },
    sendChangeEmail(element) {
      const email = element.email;
      const id = element.id;
      this.confirm = false;
      this.multiconfirm = false;
      this.$http({
        method: 'get',
        url: '/datahub/getintouch/matches',
      })
        .then((response) => {
          let user = _.find(response.data, (element) => {
            return element.email == email && element.id == id;
          });
          // metodo che invia l'email usando mailchimp api
          this.mailchimp(user);
        })
        .catch((err) => {
          console.log('match get error', err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.sub.match') });
        });
    },
    sendFinalEmail(email, id) {
      this.finalconfirm = false;
      this.$http({
        method: 'get',
        url: '/datahub/getintouch/matches',
      })
        .then((response) => {
          let user = _.find(response.data, (element) => {
            return element.google_mail == email && element.id == id;
          });
          console.log('final email. ', user);
          // metodo che invia l'email usando mailchimp api
          this.finalmailchimp(user);
        })
        .catch((err) => {
          console.log('match get error', err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.sub.match') });
        });
    },
    mailchimp(user) {
      this.$http({
        method: 'get',
        url: '/mailchimp/',
        params: user || '',
      })
        .then((response) => {
          console.log(response);
          $EventBus.$emit('message', {
            type: 'success',
            text: this.$t('error.sub.email1'),
          });
        })
        .catch((err) => {
          console.log('mailchimp get error', err);
          $EventBus.$emit('message', {
            type: 'error',
            text: this.$t('error.sub.connection'),
          });
        });
    },
    // Metodo che chiama l'invio della mail finale
    finalmailchimp(user) {
      this.$http({
        method: 'get',
        url: '/mailchimp/final',
        params: user || '',
      })
        .then((response) => {
          console.log(response);
          $EventBus.$emit('message', {
            type: 'success',
            text: this.$t('error.sub.email2'),
          });
        })
        .catch((err) => {
          console.log('mailchimp get error', err);
          $EventBus.$emit('message', {
            type: 'error',
            text: this.$t('error.sub.connection'),
          });
        });
    },
    getList(loadMore) {
      const query =
        {
          q: this.q,
          page: this.page,
          limit: this.limit,
        } || {};
      this.$http({
        method: 'get',
        url: '/datahub/getintouch/',
        params: query || {},
      })
        .then((response) => {
          if (!loadMore) {
            this.getInTouchList = response.data.data; // lista
          } else {
            this.getInTouchList = _union(this.getInTouchList, response.data.data); // appendi
          }
          this.pagination = response.data.pagination;
          this.page = response.data.pagination.currentPage;
        })
        .catch((err) => {
          console.log('lista get error', err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.sub.list') });
        });
    },
    refresh() {
      this.getList();
    },
    resetSearch() {
      this.hasSearched = null;
      this.$router.push({ path: '/getintouch', query: {} });
    },
    search() {
      const searchObject = {
        q: this.q,
        page: '1',
      };
      console.log(this.$route.query, searchObject);
      if (_.isEqual(_.pick(this.$route.query, ['q', 'page']), searchObject)) {
        this.getList();
      } else {
        this.$router.push({
          path: '/getintouch',
          query: {
            ...this.$route.query,
            ...searchObject,
          },
        });
      }
      this.hasSearched = true; // per mostrare il reset
    },
    loadMore() {
      this.getList(true);
    },
  },
  mounted() {
    this.selectedUsers = [];
    this.q = this.$route.query.q;
    if (this.$route.query.page) {
      this.page = +this.$route.query.page;
    }
    this.getList();

    this.$emit('close-menu');

    // setto e traduco gli header della tabella

    this.headers = [
      { text: this.$t('iscritti.cta4'), value: 'panel', sortable: false },
      { text: this.$t('iscritti.seleziona'), value: 'checkboxes', sortable: false },
      {
        text: this.$t('iscritti.nome') + ' ' + this.$t('iscritti.cognome'),
        value: 'name',
        sortable: false,
      },
      { text: this.$t('iscritti.email'), value: 'email', sortable: false },
      { text: this.$t('iscritti.tag'), value: 'tag', sortable: false },
      { text: this.$t('iscritti.invia1'), value: 'send_email', sortable: false },
      { text: this.$t('iscritti.status1'), value: 'is_sended', sortable: false },
      { text: this.$t('iscritti.finale'), value: 'send_final_email', sortable: false },
      { text: this.$t('iscritti.status2'), value: 'is_final_sended', sortable: false },
    ];
  },
};
</script>

<style scoped>
.g-icon {
  height: 70%;
}
</style>
